import React, {memo, Fragment} from 'react';

import ArrowRight from '../images/arrow_right.svg';

import style from './simple-teaser.module.scss';
import Columns from './columns';
import Link from './link';
import Anchor, { normalizeAnchorString } from './anchor';

export default memo(
	/**
	 * @param {{
	 *   url?: string,
	 *   anchor?: string,
	 *   headline?: React.ReactNode,
	 *   children?: React.ReactNode,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function SimpleTeaser({
		url,
		anchor,
		headline,
		children,
	}) {
		const anchorIdent = anchor && normalizeAnchorString(anchor);

		let wrappedHeadline = headline && (
			<h1 className={style.headline}>{headline}</h1>
		);

		if (wrappedHeadline && !url && anchorIdent) {
			wrappedHeadline = (
				<a
					href={`#${anchorIdent}`}
					className={style.headlineAnchorLink}
				>
					{wrappedHeadline}
				</a>
			);
		}

		const content = (
			<Fragment>
				{anchor && (
					<Anchor anchor={anchor} />
				)}

				<Columns>
					<div className={style.left}>
						{wrappedHeadline}
					</div>
					<div className={style.right}>
						{children && (
							<div className={style.text}>{children}</div>
						)}

						{url && (
							<ArrowRight className={style.more} />
						)}
					</div>
				</Columns>
			</Fragment>
		);

		if (url) {
			return (
				<Link href={url} className={style.link}>
					{content}
				</Link>
			);
		} else {
			return content;
		}
	}
);
